import {
  IGenericType,
  TGenericValues,
  TUpdateGenericBody,
} from 'interfaces/generics.interface';
import { getBasePath } from '../../utils/config';
import { safeJsonParse } from 'api/utils/fetchHelpers';
import { IgetGenericsAPIResponse } from 'api/endpoints/generics/generics.response.interface';

export const getGenericsAPI = async (
  option: IGenericType,
  token: string
): Promise<IgetGenericsAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ option: option }),
  };
  const response = await fetch(`${getBasePath()}/generic/get_generics`, params);
  return await safeJsonParse(response);
};

export const addGenericsAPI = async (
  type: IGenericType,
  values: TGenericValues[],
  token: string
): Promise<any> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      model: type,
      items: values,
    }),
  };
  const response = await fetch(`${getBasePath()}/generic/add_generics`, params);
  return await safeJsonParse(response);
};

export const updateGenericAPI = async (
  body: TUpdateGenericBody,
  token: string
): Promise<any> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/generic/update_generic`, params);
  return await safeJsonParse(response);
};
